export default "__VITE_ASSET__7GuwdTav__"